const firebaseConfig = {
  apiKey: "AIzaSyCfcztJjd4Pq-5puG2gtpSyGp15VBXaAjU",
  authDomain: "programming-club-de541.firebaseapp.com",
  projectId: "programming-club-de541",
  storageBucket: "programming-club-de541.appspot.com",
  messagingSenderId: "9914624511",
  appId: "1:9914624511:web:da32f5594ba3e4c0081fca"
};
export default firebaseConfig;